import moengage from '@moengage/web-sdk'

type Config = {
  appId: string;
  cluster: string;
  debug?: boolean;
}

function waitForMoeLoaded(timeout = 5000): Promise<void> {
  return new Promise((resolve, reject) => {
    if (moengage.isMoeLoaded()) return resolve()
    const start = Date.now()
    const interval = setInterval(() => {
      if (moengage.isMoeLoaded()) {
        clearInterval(interval)
        resolve()
      } else if (Date.now() - start > timeout) {
        clearInterval(interval)
        reject(new Error('MoEngage SDK load timeout'))
      }
    }, 100)
  })
}

export function initMoengage(config: Config) {
  const { appId, cluster, debug } = config

  moengage.initialize({
    app_id: appId,
    cluster,
    debug_logs: debug ? 1 : 0,
    enableSPA: true,
  })
}

export async function setMoengageUserId(uniqueId: string) {
  await waitForMoeLoaded()
  await moengage.identifyUser(uniqueId)
}

export async function setMoengageUserAttrs(attrs: Record<string, string | undefined>) {
  await waitForMoeLoaded()
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === null) continue
    await moengage.add_user_attribute(key, value)
  }
}

export async function trackMoengageEvent(name: string, attrs?: Record<string, any>) {
  await waitForMoeLoaded()
  await moengage.track_event(name, attrs)
}
